<script setup lang="ts">
  import { computed, getCurrentInstance } from 'vue';
  import V2MenuAllergenChips from '@/components/v2/menu-import/editor/V2MenuAllergenChips.vue';
  import { useProductEditorContext } from '@/composition/catalog/use-product-editor';
  import { isEuCountry } from '@/domain/catalog/eu-countries';
  import { allergenLabelKeys } from '@/domain/menu-import/item-editor';
  import V2CatalogEditorSection from '../shared/V2CatalogEditorSection.vue';
  import V2CatalogSettingsDisclosure from '../shared/V2CatalogSettingsDisclosure.vue';

  /**
   * «Información para el cliente» (plan §5.12): «Alérgenos», a summary row
   * that opens the chips; open from the start in the EU, where they are
   * mandatory.
   */
  const editor = useProductEditorContext();
  const proxy = getCurrentInstance()!.proxy;
  const t = (key: string) => String(proxy.$t(key));

  const form = computed(() => editor.form.value);
  const readOnly = computed(() => editor.readOnly.value);
  const allergenNames = computed(() =>
    allergenLabelKeys(form.value?.allergens ?? 0)
      .map((key) => t(key))
      .join(', ')
  );
</script>

<template>
  <V2CatalogEditorSection
    v-if="form"
    class="v2-catalog-customer-info-section"
    :title="t('menuPage.editor.customerInfo')"
    flush
  >
    <V2CatalogSettingsDisclosure
      :title="t('menuPage.editor.allergens')"
      :summary="allergenNames || t('menuPage.editor.noAllergens')"
      :default-open="!readOnly && isEuCountry(editor.country.value)"
    >
      <p v-if="readOnly" class="allergens-readonly">
        {{ allergenNames || t('menuPage.editor.noAllergens') }}
      </p>
      <V2MenuAllergenChips
        v-else
        :value="form.allergens"
        @input="editor.update('allergens', $event)"
      />
    </V2CatalogSettingsDisclosure>
  </V2CatalogEditorSection>
</template>

<style scoped lang="scss">
  .v2-catalog-customer-info-section {
    .allergens-readonly {
      @apply tw-m-0 tw-text-sm tw-text-neutral-600;
    }
  }
</style>
